(function() {

    'use strict';

    angular.module('Services').factory('Countries', countries);


    function countries () {
        return {
            getAll: []
        }
    };
})()


// WEBPACK FOOTER //
// ./js/services/Factories/Countries.js